import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-account-cog-outline',
  templateUrl: './icon-account-cog-outline.component.html',
  styleUrl: './icon-account-cog-outline.component.scss',
  standalone: false,
})
export class IconAccountCogOutlineComponent {
  @Input() tooltip?: string;
}
